import { Box, Button } from "@mui/material";
import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Routes } from "../../utils/constants";
import { appConfig } from "../../utils/configs";

const FinishAnswer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const isFinish = urlParams.get("isFinish") === "true";
  const check_plan = urlParams.get("check_plan") === "true";
  const url_respon = urlParams.get("url") ?? "";
  const urlReturn = urlParams.get("urlReturn") ?? "";
  const { title, responseCode, noti, mess, hint, url, checkPlans, note } = useMemo(() => {
    if (isFinish) {
      return {
        title: "",
        responseCode: 200,
        noti: "登録完了",
        mess: "お申込みありがとうございます。登録が完了しました。",
        hint: "お申込み登録完了のお知らせメールの詳細をご覧ください。",
      };
    }
    return location.state || {};
  }, [isFinish, location.state]);

  useEffect(() => {
    if (!checkPlans && !check_plan) {
      setTimeout(() => {
        // navigate(Routes.USER)
        const urlParams = new URLSearchParams(window.location.search);
        const event_id = urlParams.get("event");
        if(urlReturn && urlReturn !== "") {
          window.location.href = urlReturn;
        } else {
          window.location.href = event_id
            ? `${appConfig.SPA_EVENT_WEB}/marketing/event/${event_id}`
            : `${appConfig.SPA_EVENT_WEB}/marketing/event`;
        }
      }, 20000);
    }
  }, []);

  useEffect(() => {
    const metaTags = [
      {
        name: "keywords",
        content:
          "宣伝,広告,コピーライター,教育講座,SP,プロモーション,販売促進,クリエイティブ,クリエーティブ,デザイン,広報,PR,IR,編集,ライティング,環境,哲学,宣伝会議,販促会議,ブレーン,編集会議,PRIR,環境会議,人間会議,コピーライター養成講座,編集ライター養成講座,アドバタイムズ。",
      },
      {
        name: "description",
        content:
          "宣伝会議のwebサイト。広告宣伝・販促SP・広報PR・編集・広告クリエイティブなどの、出版事業と教育事業を展開しています。",
      },
    ];

    metaTags.forEach(({ name, content }) => {
      let tag = document.querySelector(
        `meta[name="${name}"]`
      ) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement("meta");
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);

  useEffect(() => {
    document.title = `【入力画面】 参加お申込みフォーム ${title}`;
  }, [title]);


  return responseCode ? (
    <>
      {/* <div className="finish-header">
        <div className="container">
          <div className="col-md-12">
            <div className="txt-14 mb-2">
              データとAIで顧客分析をレベルアップ〜GA4の先に広がるマーケティング・データクラウドの世界〜（アーカイブ配信）
            </div>
            <div className="txt-30 mb-2">参加お申込みフォーム</div>
          </div>
        </div>
      </div> */}

      <div className="container mt-4">
        {check_plan ? (
          <Box className="survey_answer-page mt20">
            <div className="col-md-12">
              <p>
                ご入力ありがとうございます。
                <br />
                <span style={{ whiteSpace: "pre-line" }}>登録はまだ完了しておりません。</span>
                <br />
                <span style={{ whiteSpace: "pre-line" }}>お手続き完了のため、チケットの購入へお進みください。</span>
              </p>
            </div>

            <div className="register-form_submit">
              <Button
                className="register-form_btn "
                onClick={async () => {
                  window.location.href = url_respon;
                }}
              >
                チケットを購入する
              </Button>
            </div>
          </Box>
        ) : (
          <Box className="survey_answer-page mt20">
            <div className="col-md-12">
              <h2>{noti}</h2>
              <p>
                {mess}
                <br />
                <span style={{ whiteSpace: "pre-line" }}>{hint}</span>
                <br />

                {checkPlans == true ? (
                  <span style={{ whiteSpace: "pre-line" }}>{note}</span>
                ) : (
                  <span style={{ whiteSpace: "pre-line" }}>自動で前の画面に戻ります。</span>
                )}
              </p>
            </div>

            <div className="register-form_submit">
              {checkPlans == true ? (
                <Button
                  className="register-form_btn "
                  onClick={async () => {
                    window.location.href = url;
                  }}
                >
                  チケットを購入する
                </Button>
              ) : (
                <Button
                  className="register-form_btn "
                  onClick={() => {
                    const urlParams = new URLSearchParams(window.location.search);
                    const event_id = urlParams.get("event");
                    const urlReturn = urlParams.get("urlReturn") ?? "";
                    if(urlReturn && urlReturn !== "") {
                      window.location.href = urlReturn;
                    } else {
                      window.location.href = event_id
                        ? `${appConfig.SPA_EVENT_WEB}/marketing/event/${event_id}`
                        : `${appConfig.SPA_EVENT_WEB}/marketing/event`;
                    }
                  }}
                >
                  前の画面に戻る
                </Button>
              )}
            </div>
          </Box>
        )}
      </div>

      {/* <div className="finish-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-12">
                  <h3>申込みの注意事項</h3>
                  <ul>
                    <li>参加希望者多数の場合は抽選とさせていただきます。</li>
                    <li>
                      プログラム内容、スケジュール、講演者はやむをえない事情で予告なく変更する場合がございます。
                      <br />
                      あらかじめご了承ください。
                    </li>
                    <li>
                      本セミナーは、学生やフリーランス、競合関係等にあたると判断した方の参加をお断りする場合がございます。あらかじめご了承ください。
                    </li>
                    <li>
                      主催者・講演者の競合関係にあたる企業のご参加はお断りする場合がございます。
                      <br />
                      あらかじめご了承ください。
                    </li>
                    <li>
                      講演者ならびに参加者に対する一方的なセールス活動はご遠慮ください。
                      <br />
                      セールス活動があった場合、以降の弊社セミナーではご参加をお断りいたします。
                    </li>
                    <li>
                      お申込み内容確認のため、フリーダイヤル（0120-679-272）よりご登録の連絡先に電話をさせていただくことがございます。
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  ) : (
    <></>
  );
};

export default FinishAnswer;
